import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { retrieveTest, getDocTypes } from "@/api/customerCenter/customerCenter";
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
export default {
  name: "writeDocument",
  mixins: [tabulation, gmToolNewPage, gmTool],
  directives: {
    'select-scroll': {
      bind: function bind(el, binding) {
        var SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');

        if (SELECTWRAP_DOM) {
          SELECTWRAP_DOM.addEventListener('scroll', function () {
            var condition = this.scrollHeight - this.scrollTop <= this.clientHeight + 1;

            if (condition) {
              binding.value();
            }
          });
        }
      }
    }
  },
  data: function data() {
    return {
      searchData: {
        page_size: 10,
        page: 1,
        doc_types: [],
        query: '',
        top_k: '',
        score_threshold: ''
      },
      tableData: [],
      total: 0,
      hasMore: false,
      searchTypeData: {
        page_size: 10,
        page: 1
      },
      documentTypeList: [],
      docTypeHasMore: false,
      // 下拉框是否还有下一页
      docTypeLoading: false
    };
  },
  created: function created() {
    console.log("this.rawData.game_mark", this.rawData.game_mark);
    this.getTypeList();

    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    }
  },
  methods: {
    getServer: function getServer() {
      var _this = this;

      this.paramsData.server_id = '';
      serverList({
        is_prod: this.paramsData.is_prod,
        page_size: ''
      }).then(function (res) {
        if (res.status == 200) {
          _this.serverList = res.data;
        }
      });
    },
    getTypeList: function getTypeList() {
      var _this2 = this;

      if (this.paramsData.server_id) {
        this.searchTypeData.server_id = this.paramsData.server_id;
      } else {
        this.searchTypeData.server_id = '';
      }

      getDocTypes(_objectSpread({}, this.searchTypeData)).then(function (res) {
        if (res.status === 'ok') {
          // 后端返回的真实字段为 doc_type 和 name
          var formattedItems = (res.items || []).map(function (item) {
            return {
              label: item.name + " (".concat(item.doc_type, ")"),
              // 拼接易读的标签
              value: item.doc_type
            };
          });
          _this2.documentTypeList = formattedItems; // 判断是否还能继续加载下一页

          _this2.docTypeHasMore = (res.items || []).length === _this2.searchTypeData.page_size;
        }
      });
    },
    loadMoreDocTypes: function loadMoreDocTypes() {
      var _this3 = this;

      // 如果正在加载中，或者已经没有更多数据了，直接拦截
      if (this.docTypeLoading || !this.docTypeHasMore) return;
      this.docTypeLoading = true;
      this.searchTypeData.page += 1; // 页码加 1

      getDocTypes(_objectSpread({}, this.searchTypeData)).then(function (res) {
        if (res.status === 'ok') {
          var nextItems = (res.items || []).map(function (item) {
            return {
              label: item.name + " (".concat(item.doc_type, ")"),
              value: item.doc_type
            };
          }); // 将新一页的数据【追加】到旧数组后面

          _this3.documentTypeList = _this3.documentTypeList.concat(nextItems); // 更新是否还有下一页的状态

          _this3.docTypeHasMore = (res.items || []).length === _this3.searchTypeData.page_size;
        }
      }).finally(function () {
        _this3.docTypeLoading = false;
      });
    },
    addDocument: function addDocument() {
      if (!this.paramsData.doc_type) {
        this.$message.error('选择文档类型');
        return;
      }

      this.$refs.addDocumetItem.open(this.paramsData.doc_type);
    },
    sizeChange: function sizeChange(val) {
      this.searchData.page_size = val;
      this.searchClick(1);
    },
    changePage: function changePage(targetPage) {
      this.searchClick(targetPage);
    },
    searchClick: function searchClick(e) {
      var _this4 = this;

      this.searchData.page = e;
      this.tableData = [];

      if (this.paramsData.server_id) {
        this.searchData.server_id = String(this.paramsData.server_id);
        this.searchData.env = this.rawData.game_mark.indexOf('yjfm') == -1 ? this.paramsData.is_prod : '';
      } else {
        this.searchData.server_id = '';
        this.$message.error('请选择服务器');
        return;
      }

      if (!this.searchData.doc_types.length) {
        this.$message.error('请选择文档类型');
        return;
      }

      if (!this.searchData.query) {
        this.$message.error('请输入问题文本');
        return;
      }

      this.searchData.env = this.paramsData.env;
      this.reqLoading = true;
      retrieveTest(_objectSpread({}, this.searchData)).then(function (res) {
        if (res.status == 'ok') {
          var list = _this4.rawData.game_mark.indexOf('royalpirates') > -1 ? _this4.serverList : _this4.serverListYJ;
          res.documents.forEach(function (item) {
            var foundData = list.find(function (b) {
              return b.serverID == item.server_id;
            });
            item.server_name = foundData ? foundData.serverName : '/';
          });
          _this4.tableData = res.documents; // let list = this.rawData.game_mark.indexOf('royalpirates') > -1 ? this.serverList : this.serverListYJ;
          // res.items.forEach(item => {
          //   let foundData = list.find(b => b.serverID == item.server_id)
          //   item.server_name = foundData ? foundData.serverName : '/'
          // })
          // this.tableData = res.items || [];

          _this4.hasMore = _this4.tableData.length == _this4.searchData.page_size;
        }
      }).finally(function () {
        _this4.reqLoading = false;
      });
    }
  }
};